/** Maps & Data heading destination (overall map page). */
export const OVERALL_MAP_PATH = '/overall-map/maps';

/** Overall map, Projects tab, with all program layers enabled by default. */
export const PROJECTS_MAP_PATH = `${OVERALL_MAP_PATH}?tab=overall-projects`;

/** Must match apiValues.NAV_OUR_PROJECTS_AND_DATA (avoid importing apiValues here). */
export const MAPS_AND_DATA_LIST_CMS_NAME = 'Header - Maps & Data - List';

export const PROJECTS_MAP_NAV_LINK = {
  key: 'projects-map',
  cmsName: 'Projects Map',
  title: 'Projects Map',
  url: PROJECTS_MAP_PATH,
};

const normalizePath = (url = '') => {
  const path = String(url).split('?')[0].replace(/\/+$/, '');
  return path || '/';
};

const isProjectsMapLink = (link = {}) => {
  const title = String(link.title || '').trim().toLowerCase();
  const cmsName = String(link.cmsName || '').trim().toLowerCase();
  const path = normalizePath(link.url);

  return (
    title === 'projects map' ||
    cmsName === 'projects map' ||
    path === OVERALL_MAP_PATH
  );
};

/**
 * Ensure Maps & Data hover menu includes an explicit Projects Map entry
 * (overall map — same destination as the Maps & Data heading).
 */
export const ensureProjectsMapNavLink = (navigationLinks = []) => {
  const links = Array.isArray(navigationLinks) ? navigationLinks.filter(Boolean) : [];
  if (links.some(isProjectsMapLink)) {
    return links;
  }
  return [PROJECTS_MAP_NAV_LINK, ...links];
};

/**
 * Apply Projects Map injection for the Maps & Data list nav only.
 * Used by every Redux write path so route changes / header reloads cannot
 * overwrite the injected link.
 */
export const withMapsAndDataProjectsMapLink = (mListNav, cmsName) => {
  if (!mListNav) return mListNav;
  const name = cmsName || mListNav.cmsName || mListNav.CMSName;
  if (name !== MAPS_AND_DATA_LIST_CMS_NAME) return mListNav;

  return {
    ...mListNav,
    navigationLinks: ensureProjectsMapNavLink(mListNav.navigationLinks),
  };
};

/**
 * Resolve initial overall-map tab from ?tab=… (validated against CMS tabs).
 */
export const resolveInitialOverallMapTab = (search = '', tabs = []) => {
  const tabList = Array.isArray(tabs) ? tabs : [];
  if (tabList.length === 0) return '';

  const query = String(search || '').startsWith('?')
    ? String(search).slice(1)
    : String(search || '');
  const params = query.split('&').reduce((obj, pair) => {
    const [rawKey, rawValue = ''] = pair.split('=');
    if (!rawKey) return obj;
    try {
      obj[decodeURIComponent(rawKey)] = decodeURIComponent(rawValue);
    } catch {
      obj[rawKey] = rawValue;
    }
    return obj;
  }, {});

  const requested = params.tab;
  if (requested && tabList.some(tab => tab && tab.id === requested)) {
    return requested;
  }
  return tabList[0].id;
};
